<template>
    <div class="create-project">
        <div v-if="isMobile" class="nav-link-container">
          <router-link class="nav-link" :to="{ name: 'portal-main' }">Главная</router-link>
          <h1 class="create-project__title">Подача заявки на проектную инициативу</h1>
          <div class="divider"></div>
        </div>
        <h1 v-if="!isMobile">Подача заявки на проектную инициативу</h1>
        <div class="shadow">
            <div class="name-controls">
                <div class="name">
                    <input
                        class="title"
                        type="text"
                        data-voicetext="Планируемое название проекта"
                        placeholder="Планируемое название проекта"
                        v-model="form.name"
                    >
                </div>

                <div class="controls" v-if="!isMobile">
                    <div
                        class="btn red"
                        @click="sendForm"
                    >Отправить</div>
                </div>
            </div>

            <div class="tabs" v-if="!isMobile">
                <div
                    class="tab"
                    v-for="(field, index) in fields"
                    :key="index"
                    :class="{ active: index == activeField }"
                    @click="$emit('change-field', index)"
                >{{ field.title }}
                </div>

                <div class="tab stub"></div>
            </div>

            <component
                :is="fields[activeField].component"
                v-model="form[fields[activeField].model]"
            />

        </div>
        <div v-if="isMobile" class="buttons-container">
          <div class="submit-button" @click="sendForm">Отправить</div>
        </div>

    </div>
</template>

<script>
import { post } from '../../tools/http';

import Common from './wide/Common';

import { mapGetters, mapActions } from 'vuex';

const getters = ['isMobile'];
const actions = [
    'showPopup',
];

const convertForm = form => {
    return {
        name: form.name,
        project_type: form.common.project_type,
        target: form.common.target,
        thematic_direction: form.common.thematic_areas,
        actuality: form.common.actuality,
        description: form.common.description,
        passport_file: form.common.passport_file || '',
        files: form.common.files.map(v => v.url),
    };
};

export default {
    name: 'WideCreateProject',
    data: () => ({
        success: {
            success: true,
            title: 'Заявка отправлена!',
            text: 'И будет обработана в ближайшее время',
            button: 'Понятно',
            color: '#4663AB',
        },

        error: {
            title: 'Произошла ошибка!',
            text: 'Заполните поля',
            button: 'Понятно',
            color: '#D1004A',
        },
    }),
    computed: {
        ...mapGetters(getters),
    },
    props: {
        fields: Array,
        activeField: Number,
        form: Object,
    },
    methods: {
        ...mapActions(actions),

        async sendForm() {
            const body = convertForm(this.form);

            const res = await post('projects', 'iniative/create', body, true);

            if (res) this.$emit('clear-form');

            this.showPopup(res ? this.success : this.error);
        },
    },
    model: {
        prop: 'form',
        event: 'change',
    },
    components: {
        Common,
    },
};
</script>

<style lang="scss">
    .create-project .tab-field {
        min-height: 19rem;

        h2 {
            font-size: 1rem;
            height: 1rem;
            margin-top: 0;
            margin-bottom: 2rem;
        }
    }
</style>

<style lang="scss" scoped>
    @import '../../styles/rem';
    @import '../../styles/mrem';

    .create-project {
        width: 80rem;
        margin: 0 auto;
    }
    .title{
        height: 2rem;
    }

    .shadow {
        background-color: #fff;
        border-radius: .2rem;
    }

    .name-controls {
        padding: 2rem;
    }

    .name {
        display: flex;

        input {
            flex-grow: 1;
            font-size: .8rem;
            padding-left: .5rem;
            border: 1px solid #b9b9b9;
            border-radius: .2rem;
        }
    }

    .controls {
        display: flex;
        margin-top: 1rem;

        .red {
            background-color: #D1004A;
            margin-right: 1rem;
        }

        .blue {
            background-color: #4663AB;
        }
    }

    .tabs {
        display: flex;
        cursor: pointer;

        .tab {
            font-size: .7rem;
            font-weight: bold;
            padding: 0 1rem .5rem;
            color: #a9a9a9;
            border-bottom: 1px solid;

            &.active {
                color: #4663AB;
            }
        }

        .stub {
            flex-grow: 1;
        }
    }

    .tab-field {
        padding: 2rem;
    }

    @import "../../styles/variables";

    @media (max-width: $vm) {

      .nav-link-container {
        padding: mrem(24) mrem(16) 0 mrem(16);
        background-color: #fff;
      }

      .nav-link {
          position: relative;
          padding-left: mrem(14);
          font-size: mrem(12);
          line-height: mrem(15);
          font-weight: 600;
          color: #bac5cb;

          &::before {
              content: url(../../assets/images/contacts/nav-arrov-icon.svg);
              position: absolute;
              left: 0;
              width: mrem(8);
              height: mrem(13);
          }
      }

      .divider {
          position: relative;
          width: 100%;
          height: mrem(1);
          margin-top: mrem(24);
          background: #d2d5d9;

          &::before {
              content: "";
              position: absolute;
              left: mrem(-16);
              width: mrem(16);
              height: mrem(1);
              background: #d2d5d9;
          }

          &::after {
              content: "";
              position: absolute;
              right: mrem(-16);
              width: mrem(16);
              height: mrem(1);
              background: #d2d5d9;
          }
      }

      .create-project {
        width: 100%;
        margin: mrem(38) 0 0 0;

        &__title {
          margin-top: mrem(24);
          font-size: mrem(24);
          line-height: mrem(29);
        }

        .name-controls {
          padding: mrem(32) mrem(16) mrem(40) mrem(16);
        }

        .name input {
          width: 100%;
          height: mrem(48);
          padding: mrem(13);
          border: mrem(1) solid #D2D5D9;
          border-radius: mrem(4);
          font-size: mrem(16);
          line-height: mrem(22);
          color: #98A0A9;

          &::placeholder {
            color: #98A0A9;
          }
        }

        .tab-field {
          padding: 0 mrem(16);
        }

      }

      .buttons-container {
        padding: mrem(20) mrem(16);
      }

      .submit-button {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: mrem(12);
        font-size: mrem(14);
        line-height: mrem(17);
        color: #fff;
        background-color: #D1004A;
        border-radius: mrem(4);
      }


    }
</style>
